<template>
  <div class="date-range-quick">
    <el-button
      v-for="item in presets"
      :key="item.key"
      size="small"
      :type="activeKey === item.key ? 'primary' : 'default'"
      plain
      @click="pick(item)"
    >{{ item.label }}</el-button>
  </div>
</template>

<script>
import {
  DATE_RANGE_PRESETS,
  matchDateRangePreset
} from '@/utils/dateRange'

export default {
  name: 'DateRangeQuick',
  props: {
    value: {
      type: Array,
      default: null
    }
  },
  computed: {
    presets() {
      return DATE_RANGE_PRESETS
    },
    activeKey() {
      return matchDateRangePreset(this.value)
    }
  },
  methods: {
    pick(item) {
      const range = item.getRange()
      this.$emit('input', range)
      this.$emit('change', range)
    }
  }
}
</script>

<style scoped>
.date-range-quick {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.date-range-quick >>> .el-button {
  margin: 0;
  padding: 7px 12px;
}
</style>
